import { render, staticRenderFns } from "./OrganizationsReport.vue?vue&type=template&id=793d5409&"
import script from "./OrganizationsReport.vue?vue&type=script&lang=js&"
export * from "./OrganizationsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports